<div class="h-full flex flex-col">
  @if (packageId() && isPackageLoading()) {
    <div class="flex-1 flex items-center justify-center">
      <app-loading-spinner withLogo></app-loading-spinner>
    </div>
  } @else if (currentPage() === 1) {
    <app-sidebar-header>
      <div smallTitle>{{ packageId() ? 'Edit ' : 'Add ' }}Submittal Package</div>
      <div mainTitle>SUBMITTAL PACKAGE DETAILS</div>
    </app-sidebar-header>
    <ng-scrollbar
      class="std-scrollbar first-page wider-track"
      appearance="compact"
      visibility="native"
      orientation="vertical"
    >
      <div class="mb-5 mt-4 horizontal-spacing scrollable-content">
        <form class="flex flex-col flex-1" #submittalForm="ngForm" role="form" [@fadeInGeneral]>
          <div class="flex-1 flex flex-col">
            <!-- Package ID / Spec Section and Package Version -->
            <div class="flex justify-between items-center gap-2.5">
              <app-floating-input
                id="spec_section"
                label="Package ID / Spec Section"
                placeholder="##.####"
                name="spec_section"
                [ngModel]="model().spec_section"
                (ngModelChange)="updateModel('spec_section', $event)"
                class="flex-1"
                required
                [pattern]="SPEC_SECTION_REGEX"
                [filterInputBasedOnPattern]="true"
              ></app-floating-input>
              <app-floating-input
                id="package_version"
                label="Package Version"
                placeholder="Package Version"
                name="package_version"
                [ngModel]="model().package_version"
                (ngModelChange)="updateModel('package_version', $event)"
                [disabled]="true"
                class="flex-1"
              ></app-floating-input>
            </div>

            <!-- Package Title -->
            <div class="flex justify-between items-center gap-2.5">
              <app-floating-input
                id="package_title"
                label="Package Title"
                placeholder="Package Title"
                name="package_title"
                [ngModel]="model().package_title"
                (ngModelChange)="updateModel('package_title', $event)"
                class="w-full"
                required
              ></app-floating-input>
            </div>

            <!-- Submittals Due Date -->
            <div class="flex justify-between items-center gap-2.5">
              <app-input-calendar
                #submittals_due_date_calendar
                [required]="true"
                [date]="model().submittals_due_date"
                [minStartDate]="projectData()?.start_date"
                (dateChanged)="updateDueDate($event)"
                placeholder="Submittals Due Date"
                class="w-full"
                [showIcon]="true"
              ></app-input-calendar>
            </div>

            <!-- Submittal Manager -->
            <div class="flex justify-between items-center gap-2.5">
              <app-dropdown
                [required]="true"
                name="submittal_manager"
                [ngModel]="model().package_manager_id"
                (ngModelChange)="updateModel('package_manager_id', $event)"
                [options]="teamMembers()"
                [isLoading]="false"
                optionLabel="name"
                optionValue="id"
                label="Submittal Manager"
                placeholder="Select Submittal Manager"
                class="w-full"
              >
                <ng-template #selectedContent #optionContent let-option>
                  <div class="flex flex-col">
                    <div class="text-navy-900 font-semibold">{{ option?.name }}</div>
                    <div class="text-navy-900 font-normal">{{ option?.company_name }}</div>
                  </div>
                </ng-template>
              </app-dropdown>
            </div>

            <!-- Approving -->
            <div class="flex justify-between items-center gap-2.5">
              <app-dropdown
                [required]="true"
                name="approving"
                [ngModel]="model().package_approver_id"
                (ngModelChange)="updateModel('package_approver_id', $event)"
                [options]="invitedMembers()"
                [isLoading]="invitedMembersIsLoading()"
                optionLabel="name"
                optionValue="id"
                label="Approving"
                placeholder="Select Approving"
                class="w-full"
              >
                <ng-template #selectedContent #optionContent let-option>
                  <div class="flex flex-col">
                    <div class="text-navy-900 font-semibold">{{ option?.name }}</div>
                    <div class="text-navy-900 font-normal">{{ option?.company_name }}</div>
                  </div>
                </ng-template>
              </app-dropdown>
            </div>

            <!-- Participants (Optional) -->
            <app-tag-dropdown
              name="participants"
              [label]="'Participants'"
              [ngModel]="model().participants"
              (ngModelChange)="updateModel('participants', $event)"
              [availableTags]="invitedMemberOptions()"
              [isLoading]="invitedMembersIsLoading()"
              [required]="false"
              class="flex-1"
            ></app-tag-dropdown>
          </div>
        </form>
      </div>
    </ng-scrollbar>
    <div class="bottom-container text-navy-700 text-base font-bold">
      <div class="flex items-center ml-auto">
        <app-simple-button buttonStyle="color_secondary_filled" [isLoading]="isSubmitting()" (click)="nextPage()">
          Next
        </app-simple-button>
      </div>
    </div>
  } @else if (currentPage() === 2) {
    <app-submittal-registry-items
      [packageId]="packageId()"
      [(model)]="model"
      (savePackage)="save()"
      (goBackPage)="previousPage()"
    ></app-submittal-registry-items>
  }
</div>
